module.exports = __webpack_public_path__ + "static/img/Homev2.2b8169c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/Homev2.png
// module id = yAkE
// module chunks = 0